import gql from 'graphql-tag'

export default gql`
  query getServiceLine($id: String!) {
    getExpert(id: $id) {
      id

      legacyMetadata {
        primaryServiceLine
      }

      onboardingStep
    }
  }
`
